<template>
	<div>
		<Report
			:loadedconfig="loadedconfig"
			:studentid="studentid"
			:selectStudent="selectStudent"
            :hideTargets="hideTargets"
            :includeTimeSeries="includeTimeSeries"
		/>
	</div>
</template>

<script>
import Report from "../../components/Reports/Report";

export default {
	components: {
		Report
	},
	data() {
		return {
			loadedconfig: null,
			studentid: null,
            hideTargets: null
		};
	},
	mounted() {
		if(this.$UserSession.hasPriv('REPORT_ALLSTUDENTS')){
			if(this.$route.params.studentid) {
				this.studentid = this.$route.params.studentid;
				this.getReportConfig();
			} else {
				this.selectStudent();
			}
		} else {
			this.studentid = this.$UserSession.getValue('id');
			this.getReportConfig();
		}
	},
	methods: {
		unableToGetSettings() {
			const self = this;
			this.$store.commit("openDialog" , {
				title: this.$t('oops'),
				content: this.$t('unable-to-get-report-settings'),
				confirmCallBack: function(){
					self.$router.replace('/');
				}
			});
		},
		selectStudent() {
			const self = this;
			this.$users.getStudents.call(this).then(students => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-student"),
					selectCallback: function(selection) {
						self.$store.commit("closeModal");
						self.studentid = selection.id
						self.getReportConfig();
					},
					selected: [
					],
					data: students,
					captionKey: "displayName",
                    subcaptionKey: "studentid",
					studentSearchFilters: true
				});
			});
		},
		getReportConfig(){
			this.$store.commit("showBlockingSpinner");

			const data = {};
			if(this.$UserSession.hasPriv('REPORT_ALLSTUDENTS')){
				if(this.studentid) {
					data.student_id = this.studentid;
				} else {
					return false;
				}
			}

			this.$cfetch(`${this.$settings.APIBaseURL}/reporting/report/${this.$route.params.reportid}`, {
				cache: false,
				data
			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status === "SUCCESS") {
					this.$log.info.call(this, "Report config loaded");
					this.loadedconfig = json.result;
                    this.hideTargets = json.hide_targets;
				} else {
					this.$log.error.call(this, "Could not fetch report settings");
					this.unableToGetSettings();
				}
			})
			.catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.unableToGetSettings();
				this.$log.error.call(this, error);
			});
		}
	},
	computed: {
		includeTimeSeries() {
			// Temporarily disabling this, because it is broken!
			//return false;
			return this.$UserSession.hasPriv('SUPERADMIN')
		}
	}
};
</script>
